import { ITariffCondition } from "../../../models/management/tariff/ITariffData";
import { RootState } from "../../store";

export const tariffTypesSelector = (state: RootState): ITariffCondition[] => {
    return state.managementTariffList.listTariffCondition;
};
